import { API } from 'aws-amplify';
import * as CDKFeedback from './feedback-cdk';
import cdkConfig from '../config/cdk-exports';
import { FeedbackData } from './FeedbackService';
import { FeedbackResponse } from '../types/feedback';
import logger, { BackendType } from '../utils/logger';

/**
 * Bridge service that routes feedback operations to either Amplify or CDK backend
 * based on feature flags in the configuration
 */

/**
 * Submit feedback to the backend
 * @param data The feedback data to submit
 * @returns Promise with the response
 */
export const submitFeedback = async (data: FeedbackData): Promise<FeedbackResponse> => {
  // Use CDK Lambda if the feature flag is enabled
  if (cdkConfig.features.useLambdaCDK) {
    logger.info('Submitting feedback to CDK Lambda', BackendType.CDK, { email: data.email, type: data.feedbackType });
    return CDKFeedback.submitFeedback(data);
  } else {
    logger.info('Submitting feedback to Amplify API', BackendType.AMPLIFY, { email: data.email, type: data.feedbackType });
    
    try {
      // Call the feedbackapi endpoint with the feedback data
      const response = await API.post('feedbackapi', '/feedback', { 
        body: data,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      logger.info('Feedback API response received', BackendType.AMPLIFY, response);
      
      return {
        success: true,
        message: 'Feedback submitted successfully',
        id: response.id || `feedback_${Date.now()}`
      };
    } catch (error) {
      logger.error('Error submitting feedback', BackendType.AMPLIFY, error);
      
      // Format the error response
      const errorResponse: FeedbackResponse = {
        success: false,
        message: error instanceof Error ? error.message : 'An error occurred while submitting feedback',
        error: 'UNKNOWN_ERROR'
      };
      
      throw errorResponse;
    }
  }
};
